import { generatePath } from "react-router-dom"
import { companyBasePath } from "../../utils/baseRoutes"

// EXPENSES
const _expensesPath = (companyId: string, path?: string) => {
  return companyBasePath({ companyId, path: generatePath("expenses/*", { "*": path || "" }) })
}

export const companyExpensesPath = (companyId: string) => {
  return _expensesPath(companyId)
}

export const companyNewExpensePath = (companyId: string) => {
  return _expensesPath(companyId, "new")
}

// SUBSCRIPTIONS
export const companySubscriptionsPath = (companyId: string) => {
  return companyBasePath({ companyId, path: "subscriptions" })
}
